export const FLOOR_PLAN_COLORS = Object.freeze({
  defaultSeatFill: '#D9D9D9',
  fallbackTicketFill: '#979797',
  multiTicketFill: '#292929',
  soldSeatFill: '#F5F5F5',
  soldSeatStroke: '#A1A0A0',
  selectedSeatFill: 'white',
  selectedSeatStroke: '#333333',
  sectionFallbackFill: '#D0CCCC',
  zoomIconActive: '#0277BD',
  zoomIconDisabled: '#D9D9D9',
})

export const FLOOR_PLAN_STATS_STYLES = Object.freeze({
  free: `background: ${FLOOR_PLAN_COLORS.defaultSeatFill};`,
  marked:
    'background: conic-gradient(from 180deg at 50% 50%, #F00 0deg, #FFC700 48.60000193119049deg, #05FF00 109.80000257492065deg, #0FF 174.6000051498413deg, #0AF 226.79999828338623deg, #5D00FF 282.60000944137573deg, #FF00C7 360deg);',
  selected: `background: ${FLOOR_PLAN_COLORS.selectedSeatFill};border: 3px solid ${FLOOR_PLAN_COLORS.selectedSeatStroke};`,
  multiTicket: `background: ${FLOOR_PLAN_COLORS.multiTicketFill};border:1px solid ${FLOOR_PLAN_COLORS.defaultSeatFill};`,
  sold: `background: ${FLOOR_PLAN_COLORS.soldSeatFill};border: 1px solid ${FLOOR_PLAN_COLORS.soldSeatStroke};`,
  unavailable: `background: ${FLOOR_PLAN_COLORS.defaultSeatFill};`,
})

export const ARENA_SECTION_COLOR_ZOOM_LIMIT = 1.9
